import React, {FC} from 'react'

import cn from 'classnames/bind'
import {observer} from 'mobx-react-lite'

import InputDate from 'components/elements/fields/InputDate'
import MobxSelect from 'components/elements/fields/MobxSelect'
import MobxTextInput from 'components/elements/fields/MobxTextInput'
import {termsOptions} from 'src/models/Invoice/Invoice.configs'
import {useRootStore} from 'src/utils/contexts/RootStore.context'

import s from './FieldsInvoiceTerms.module.scss'

const cx = cn.bind(s)

interface IFieldsInvoiceTermsProps {
	className?: string
}

const FieldsInvoiceTerms: FC<IFieldsInvoiceTermsProps> = ({className}) => {
	const store = useRootStore()
	return (
		<fieldset className={cx('wrapper', className)}>
			<MobxTextInput
				wrapperClassName={cx('input-spaces')}
				label="Number"
				placeholder="INV2156"
				store={store.invoice}
				name="number"
			/>
			<InputDate
				wrapperClassName="mt-2"
				labelAs="div"
				label="Date"
				required={false}
				onChange={(v: Date) => {
					store.invoice.date = v
				}}
				value={store.invoice.date}
			/>

			<MobxSelect
				wrapperClassName="mt-2"
				name="terms"
				store={store.invoice}
				label="Terms"
				options={termsOptions}
			/>

			{store.invoice.terms !== 'none' && store.invoice.terms !== 'on_receipt' && (
				<InputDate
					wrapperClassName="mt-2"
					label="Date"
					onChange={(v: Date) => {
						store.invoice.setCustomDue(v)
					}}
					value={store.invoice.due}
				/>
			)}
		</fieldset>
	)
}

FieldsInvoiceTerms.displayName = 'FieldsInvoiceTerms'

export default observer(FieldsInvoiceTerms)
